/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the OrderFlagAssignRequestDTO interface.
 */
export function instanceOfOrderFlagAssignRequestDTO(value) {
    return true;
}
export function OrderFlagAssignRequestDTOFromJSON(json) {
    return OrderFlagAssignRequestDTOFromJSONTyped(json, false);
}
export function OrderFlagAssignRequestDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'flagId': json['flagId'] == null ? undefined : json['flagId'],
    };
}
export function OrderFlagAssignRequestDTOToJSON(json) {
    return OrderFlagAssignRequestDTOToJSONTyped(json, false);
}
export function OrderFlagAssignRequestDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'flagId': value['flagId'],
    };
}
